<template>
    <div class="markets-header">
        <app-header v-if="this.$route.params.page === 'building-and-architecture'" :cover="coverBuilding" :texts="['Строителство и архитектура']"></app-header>
        <app-header v-if="this.$route.params.page === 'automotive'" :cover="coverAutomotive" :texts="['Автомобилостроене']"></app-header>
        <app-header v-if="this.$route.params.page === 'transportation'" :cover="coverTransportation" :texts="['Транспорт']"></app-header>
        <app-header v-if="this.$route.params.page === 'packaging'" :cover="coverPackaging" :texts="['Опаковки']"></app-header>
        <app-header v-if="this.$route.params.page === 'distribution'" :cover="coverDistribution" :texts="['Дистрибуция']"></app-header>
    </div>
</template>

<script>
import Header from "../shared/Header";
export default {
  components: {
    appHeader: Header
  },
  data() {
    return {
      coverPackaging: ["/static/img/markets/packaging/header.jpg", "image"],
      coverBuilding: ["/static/img/markets/building/header.jpg", "image"],
      coverTransportation: [
        "/static/img/markets/transportation/header.jpg",
        "image"
      ],
      coverAutomotive: ["/static/img/markets/automotive/header.jpg", "image"],
      coverDistribution: [
        "/static/img/markets/distribution/header.jpg",
        "image"
      ]
    };
  }
};
</script>

<style scoped>
.markets-header {
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Header.vue